<template>
    <table id="example1" class="table table-bordered table-striped table-hover">
        <thead>
        <tr>
            <th class="text-nowrap">Fecha</th>
            <th class="text-nowrap"><i class="fa fa-database" aria-hidden="true"></i> Registro</th>
            <th class="text-nowrap">Valor</th>
            <th class="text-nowrap">Unidad</th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="(measure, index) in measures" :key="measure.id">
            <td>{{ format_date(measure.measured_at) }}</td>
            <td><a :href="'/control/projects/' + this.projectUUID + '/element_keys/' + measure.element_key_uuid">{{ measure.element_key_name }}</a> <i class="fa fa-bar-chart" aria-hidden="true"></i></td>
            <td>{{ measure.value_key }}</td>
            <td>{{ measure.value_unit_name }} ({{ measure.value_unit }})</td>
        </tr>
        </tbody>
    </table>
</template>

<script>
import {mapState} from 'vuex';

export default {
    computed: mapState(['measures']),
    data() {
        return {
            'projectUUID': this.getProjectUUID(),
            'elementUUID': this.getElementUUID()
        }
    },
    created() {
        axios.get('/api/v1/elements/' + this.elementUUID + '/measures')
            .then(response => {
                this.$store.commit('setMeasures', response.data.data);
            })
            .catch(error => {
                console.log("Error", error)
            })
    },
    methods: {
        format_date(value) {
            //TODO: DRY global?
            if (value) {
                return window.moment(String(value)).format('DD-MM-YYYY hh:mm:ss')
            }
        },
        getProjectUUID() {
            //TODO: DRY
            let projectUUID = document.head.querySelector('meta[name="meta-projectUUID"]');

            if (projectUUID) {
                return projectUUID.content;
            }
            else {
                console.error('projectUUID meta not found.');
            }
        },
        getElementUUID() {
            //TODO: DRY
            let elementUUID = document.head.querySelector('meta[name="meta-elementUUID"]');

            if (elementUUID) {
                return elementUUID.content;
            }
            else {
                console.error('elementUUID meta not found.');
            }
        }
    }
}
</script>
